import {useEffect} from "react";
import {batch, useComputed, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {
	productPagesKpiIsEmpty,
	evolutionDataFilters,
	productPagesKpiSubmittedFilters,
	productPageKpiFilters, productPagesKpiReportFormIsOpen
} from "../@signals";
import useProductPageKpiRoleConfig from "./useRoleConfig";


export default function useProductPagesKpiFilters() {
	const { urlApi } = useProductPageKpiRoleConfig()

	const aggregation = useSignal([])
	const mergeKeys = useSignal([])
	const kpis = useSignal([])

	const dataContext = useSignal([])
	const isLoadingContext = useSignal(false)

	// `weighted_score` viaja en cada fila del context desde 2026-08-19: la segunda llamada (y su
	// merge por mergeKeys) desapareció — era el mismo motor calculado dos veces en HeatWave.
	const isRequestFinished = useComputed(() =>
		!isLoadingContext.value
	)

	const isLoading = useComputed(() =>
		isLoadingCommonFilters.value || isLoadingContext.value
	)

	const data = useComputed(() => {
		if (isLoading.value) return []
		return dataContext.value
	})


	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {

			evolutionDataFilters.value = {}
			dataContext.value = []

			isLoadingContext.value = true
			productPagesKpiSubmittedFilters.value = commonFiltersValue.peek()
			postSubmit(urlApi, { ...commonFiltersValue.value }).then(res => {
				if (!res.data?.length) productPagesKpiIsEmpty.value = true
				dataContext.value = res.data
				aggregation.value = res.aggregation
				mergeKeys.value = res.mergeKeys
				kpis.value = res.kpis
				productPageKpiFilters.value = res.kpis.map(item => {
					const {label, ...content} = item
					return {value: label, label: label, ...content}
				})
			}).catch(() => {
				isLoadingContext.value = false
				isLoadingCommonFilters.value = false
				isSystemBusy.value = true
			}).finally(() => { isLoadingContext.value = false })

		})
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if(isRequestFinished.value)
			isLoadingCommonFilters.value = false
	}, [isRequestFinished.value])

	return {
		data: data.value,
		aggregation: aggregation.value,
		kpis: kpis.value,
		isLoading: isLoading.value,
	}
}